import { Route } from '@angular/router';
import { RouteLanguageResolver } from '@hazmatsuite-next/ui';
import { DownloadComponent } from './components/download/download.component';
import { GeneralInformationComponent } from './components/general-information/general-information.component';
import { PackingListComponent } from './components/packing-list/packing-list.component';
import { PreviewComponent } from './components/preview/preview.component';
import { TransportmodeComponent } from './components/transportmode/transportmode.component';
import { initialDataResolver } from './resolver/initial-data.resolver';
import { downloadPageResolver } from './resolver/download-page.resolver';
import { initStepperResolver } from './resolver/init-stepper.resolver';

const requiredResources = [
  'LayoutResource',
  'ValidationResource',
  'AddressEditorResource',
  'AddressListResource',
  'EasyDgdCommonResource',
  'CompositePackagingResource',
  'DangerousGoodListResource',
  'DownloadResource',
  'GeneralInformationResource',
  'PackingListResource',
  'ShippingPaperListResource',
  'SinglePackagingResource',
  'EasyDgdTransportModeResource',
  'CommonResource',
  'PaymentResources',
];

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'de/easydgd',
    pathMatch: 'full',
  },
  {
    path: 'de/EasyDgd',
    redirectTo: 'de/easydgd/transportmode',
  },
  {
    path: 'de/easydgd',
    redirectTo: 'de/easydgd/transportmode',
    data: {
      resources: requiredResources,
    },
  },
  {
    path: ':lang/easydgd',
    resolve: { lang: RouteLanguageResolver },
    data: {
      resources: requiredResources,
    },
    children: [
      {
        path: 'transportmode',
        component: TransportmodeComponent,
        resolve: { steps: initStepperResolver }
      },
      {
        path: 'generalinformation',
        component: GeneralInformationComponent,
        resolve: { steps: initStepperResolver, data: initialDataResolver },
      },
      {
        path: 'packinglist',
        component: PackingListComponent,
        resolve: { steps: initStepperResolver, data: initialDataResolver },
      },
      {
        path: 'preview',
        component: PreviewComponent,
        resolve: { steps: initStepperResolver, data: initialDataResolver },
      },
      {
        path: 'download',
        component: DownloadComponent,
        resolve: { steps: initStepperResolver, data: initialDataResolver, download: downloadPageResolver },
      },
      {
        path: 'addresslist',
        loadChildren: () =>
          import('@hazmatsuite-next/address-list').then(
            (m) => m.AddressListModule
          ),
      },
    ]
  }

  // {
  //   path: 'en/easydgd',
  //   component: CalculationComponent,
  //   resolve: { lang: RouteLanguageResolver },
  //   data: {
  //     resources: requiredResources,
  //   },
  // },
  // {
  //   path: 'fr/EasyDgd',
  //   component: CalculationComponent,
  //   resolve: { lang: RouteLanguageResolver },
  //   data: {
  //     resources: requiredResources,
  //   },
  // },
  // {
  //   path: 'fr/easydgd',
  //   component: CalculationComponent,
  //   resolve: { lang: RouteLanguageResolver },
  //   data: {
  //     resources: requiredResources,
  //   },
  // },
  // {
  //   path: ':lang/EasyDgd',
  //   component: CalculationComponent,
  //   resolve: { lang: RouteLanguageResolver },
  //   data: {
  //     resources: requiredResources,
  //   },
  // },
  // {
  //   path: ':lang/easydgd',
  //   component: CalculationComponent,
  //   resolve: { lang: RouteLanguageResolver },
  //   data: {
  //     resources: requiredResources,
  //   },
  // }
];
